import FeatureGates from '@atlaskit/feature-gate-js-client';

// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/cc-notifications_flyout_messaging/setup
const FLYOUT_MESSAGING_EXPERIMENT_NAME = 'cc-notifications_flyout_messaging';
const COHORT_PARAM_NAME = 'cohort';

export enum ExperimentParameterValues {
	CONTROL = 'control',
	TEST = 'test',
	NOT_ENROLLED = 'not-enrolled',
}

export const isFlyoutExperimentEnabled = (): boolean => {
	return (
		FeatureGates.getExperimentValue<ExperimentParameterValues>(
			FLYOUT_MESSAGING_EXPERIMENT_NAME,
			COHORT_PARAM_NAME,
			ExperimentParameterValues.NOT_ENROLLED,
		) === ExperimentParameterValues.TEST
	);
};
